module.exports = __webpack_public_path__ + "static/img/baseball.22845a5.jpg";